import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, SimpleChange} from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray} from '@angular/forms';
import { AccountService } from '../account.service';
import { Device } from '../models/kiosk';
import { timezones } from '../models/timezones';
import { Observable } from 'rxjs/Observable';
import { startWith, map } from 'rxjs/operators';
import { KioskService } from '../kiosk.service';

@Component({
  selector: 'app-kiosk-edit',
  templateUrl: './kiosk-edit.component.html',
  styleUrls: ['./kiosk-edit.component.css'],
})
export class KioskEditComponent implements OnInit, OnChanges {
  @Input() kiosk;
  @Output() kioskChanged: EventEmitter<any> = new EventEmitter<any>();
  formGroup: FormGroup;

  loading = false;
  timezones: any = timezones;
  stateGroupOptions: Observable<any[]>;

  constructor(
    private _fb: FormBuilder,
    private _accountService: AccountService,
    private _kioskService: KioskService
  ) {}

  ngOnInit() {
    this.setupTimezoneFilter();
    this.setKiosk(this.kiosk);
  }

  ngOnChanges(changes: SimpleChanges) {
    const kiosk: SimpleChange = changes.kiosk;

    this.setKiosk(kiosk.currentValue);
  }

  setKiosk(kiosk: any) {
    this.createForm();
    if (kiosk) {
      this.formGroup.get('multi_tenant').setValue(kiosk.multi_tenant);
      this.formGroup.get('timezone').setValue(kiosk.timezone);
      this.formGroup.get('nickname').setValue(kiosk.nickname);
      this.formGroup.get('cellphone_number').setValue(kiosk.cellphone_number);
      this.formGroup.get('locked').setValue(kiosk.locked);
      this.formGroup.get('company').setValue(kiosk.company);

      kiosk.tenants.forEach(el => {
        const a = <FormArray>this.formGroup.controls['tenants'];

        const b = this.createFormTenant();
        b.get('account_id').setValue(el.account_id);
        this._kioskService.getFolder(el.folder_id).subscribe((folder: any) => {
          const ownerAccountID = folder.folder_relationships.find((x) => x.permission === 1).account_id;
          this._accountService.byId(ownerAccountID).subscribe((data) => {
            b.get('email').setValue(data.email);
          });
        });

        a.push(b);

      });


    }
  }
  setupTimezoneFilter() {
    this.stateGroupOptions = this.formGroup.get('timezone').valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterGroup(value))
      );
  }

  createForm(): any {
    this.formGroup = this._fb.group({
      multi_tenant: [false, Validators.required],
      timezone: ['', Validators.required],
      nickname: ['', Validators.required],
      cellphone_number: ['', Validators.required],
      locked: [false, Validators.required],
      company: ['', Validators.required],
      tenants: this._fb.array([], [Validators.minLength(1), Validators.maxLength(4)]),
    });

    this.formGroup.valueChanges.subscribe((data) => {
      console.log("value changed", data)
      this.kioskChanged.emit(data);
    });
  }

  saveKiosk() {
    console.log('saving kiosk details');

  }

  private _filterGroup(value: string): any[] {
    console.log("_filterGroup", value)
    if (value) {
      return this.timezones
        .map(group => ({ heading: group.heading, zones: _filter(group.zones, value) }))
        .filter(group => group.zones.length > 0);
    }

    return this.timezones;
  }

  inviteAccount(acc) {
    console.log('inviting account', acc);
    if (this.formGroup.get('tenants').value.filter((x: any) => x.account_id === acc.id).length === 0) {
      const a = <FormArray>this.formGroup.controls['tenants'];

      const b = this.createFormTenant();
      b.get('account_id').setValue(acc.id);
      b.get('email').setValue(acc.email);

      a.push(b);
    }
  }

  createFormTenant(): FormGroup {
    return this._fb.group({
      email: ['', Validators.required],
      account_id: ['', Validators.required],
      name: ['', Validators.required],
    });
  }

  removeMember(i: number) {
    const a = <FormArray>this.formGroup.controls['tenants'];
    a.removeAt(i);
  }


}

export const _filter = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => {
    return item.toLowerCase().includes(filterValue);
  });
};


// WEBPACK FOOTER //
// ./src/app/kiosk-edit/kiosk-edit.component.ts